<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div>
          <div class="box-header">
            <h3 class="box-title">Update Subtrips</h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                <div class="alert" :class="'alert-' + flashType">
                  {{ flashMessage }}
                </div>
              </div>
            </div>
            <div id="details">
              <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                <div class="col-sm-12">
                  <div class="col-sm-6">
                    <label>Trip Code</label>
                  </div>
                  <div class="col-sm-6">
                    <label class="form-control">
                      {{ trip.tripGroupCode }}
                    </label>
                  </div>
                </div>
                <br /><br />
                <!-- <div class="col-sm-12">
                  <div class="col-sm-6">
                    <label>Present Destination</label>
                  </div>
                  <div class="col-sm-6">
                    <label class="form-control"
                      >{{ trip.endSiteSiteName }}
                    </label>
                  </div>
                </div>
                <br /><br /> -->
                <div class="col-sm-12">
                  <!-- <div class="col-sm-6">
                                        <label> New Destination </label>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field"
                                            :class="fieldClassName(formstate.endSite)">
                                            <select v-model="tripException.divertedDestination" required
                                                name="divertedDestination" class="form-control">
                                                <option disabled>Select Location</option>
                                                <option v-for="(item, index) in site_name" :key="index" :value="item.key">
                                                    {{ item.value }}
                                                </option>
                                            </select>
                                            <field-messages name="endSite" show="$touched || $submitted"
                                                class="form-control-feedback">
                                                <div slot="required">This is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div> -->

                  <div v-for="(input, index) in locations" :key="index" class="">
                    <div class="col-sm-6">
                      <label v-if="index === 0">Start Location</label>
                      <label v-else-if="index === locations.length - 1">End Location</label>
                      <label v-else>Halt {{ index }}</label>
                    </div>
                    <div class="col-sm-6">
                      <validate auto-label class="form-group required-field">
                        <select v-model="input.locationId" required class="form-control"
                          @change="handleChange($event, index)">
                          >
                          <option selected disabled>Select Location</option>
                          <option v-for="(item, itemIndex) in getFilteredLocationList(
                            index,
                          )" :key="itemIndex" :value="item">
                            {{ item.siteName }}
                          </option>
                        </select>
                        <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                          <div slot="required">
                            HCV Operation Manager is a required field
                          </div>
                        </field-messages>
                      </validate>
                      <svg v-if="index === locations.length - 2" @click="addField('locations')"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                        class="ml-2 cursor-pointer svg-icons">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path fill="green"
                          d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" />
                      </svg>
                      <svg v-if="index > 1 && index < locations.length - 1" @click="removeField(index, 'locations')"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                        class="ml-2 cursor-pointer svg-icons">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path fill="#EC4899"
                          d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <br /><br />
              </vue-form>

              <br /><br />
              <div class="col-sm-12 text-right">
                <router-link :to="{ name: 'TripGroup' }">
                  <button class="mr-5 btn btn-default" type="button">
                    Cancel
                  </button>
                </router-link>
                <!-- :disabled="!(formstate.$dirty && formstate.$valid)" -->
                <button class="mr-2 btn gradientbt" type="submit" @click="updateSubTrips">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="gasFlowDia" height="425" :adaptive="false" :click-to-close="false">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          <!-- <b>{{editGasFlow.title}}</b> -->
          <button type="button" class="close" aria-label="Close" @click="$modal.hide('gasFlowDia')">
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>
      </div>

      <div class="modal-body">
        <table class="table table-bordered">
          <tr style="marginTop:10px">
            <th>Start Location:</th>
            <td>
              <input class="form-control" required v-model="routeData.startLocation" placeholder="Approx. Distance"
                disabled />
              <!-- <datetime type="datetime" v-model="routeData.startLocation" use12-hour></datetime> -->
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>End Location:</th>
            <td>
              <input class="form-control" required v-model="routeData.endLocation" placeholder="Approx. Distance"
                disabled />
              <!-- <datetime type="datetime" v-model="trip.startDate" use12-hour></datetime> -->
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Approx. Time (in Min) :</th>
            <td>
              <input type="number" class="form-control" required v-model="routeData.time"
                placeholder="Approx. Distance" />
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Approx. Distance(km) :</th>
            <td>
              <input type="number" class="form-control" required v-model="routeData.distance"
                placeholder="Approx. Distance" />
            </td>
          </tr>
          <!-- <tr style="marginTop:10px">
            <th>Region :</th>
            <td>
              <select v-model="routeData.region" required name="region" class="form-control">
                <option value="" disabled>Select G.A</option>
                <option v-for="(item, index) in region_list" :key="index" :value="item.key">
                  {{ item.value }}
                </option>
              </select>
            </td>
          </tr> -->

          <!-- <tr v-if="trip.status == 'ongoing'">
                  <th>Change Trip Status</th>
                  <td>
                    <select class="form-control" @change="changeStatus" v-model="statusValue">
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                </tr> -->
        </table>

        <div class="text-right" style="margin-top:20px">
          <button class="btn btn-primary" @click="closeRoute()">Close</button>
          <button class="btn btn-primary" @click="createRoute()">Save</button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import {
  formService,
  eventBus,
  tripService,
  tripExceptionService,
  tripRouteService
} from '../../../services';
import {
  EVENTS
} from '../../../config';

export default {
  name: 'UpdateLocations',
  data() {
    return {
      clearIndex: null,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      site_name: '',
      trip: {
        status: 'active',
      },
      locations: [{
        locationId: '',
      },
      {
        locationId: '',
      },
      {
        locationId: '',
      },
      ],
      locationList: [],

      tripException: {
        prevDestination: '',
        docId: '',
      },
      trip: {},
      routeData: {
        startLocation: '',
        endLocation: '',
        time: '',
        distance: '',
        startLocId: '',
        endLocId: '',
        routeMarkers: [{
          latitude: '',
          longitude: '',
          message: '',
        },
        {
          latitude: '',
          longitude: '',
          message: '',
        }],

      },
      list: [],
      route_name: {},
      matchingRoutes: [],
      regionId: '',
    };
  },
  mounted() {
    this.getTrip();
    // this.getSite();
    this.getRouteName();
  },
  methods: {
    fieldClassName: formService.fieldClassName,

    //get trip data
    getTrip() {
      return this.$tripGroupDataRepository
        .getIndividualGroupTrip(this.$route.params._id)
        .then(response => {
          this.trip = response.data.data[0];
          this.regionId = this.trip.geographical_area;


          this.getLocations();
        })
        .catch(error => {
          this.$snotify.error('Trip detail failed', 'Error!');
        });
    },

    getFilteredLocationList(index) {
      //0th index selected LNGT then all other must be LNGT
      //otherwise all must be according to condition
      var stations = [];
      if (
        this.locations[0] &&
        this.locations[0].locationId.siteType === 'LNGT'
      ) {
        if (index === 0) {
          stations = this.locationList.filter(
            el => el.siteType === 'MS' || el.siteType === 'LNGT',
          );
        } else {
          stations = this.locationList.filter(el => el.siteType === 'LNGT');
        }
      } else if (
        (index === 0 || index === this.locations.length - 1) &&
        this.locations[0].locationId.siteType !== 'LNGT'
      ) {
        stations = this.locationList.filter(
          el => el.siteType === 'MS' || el.siteType === 'LNGT',
        );
      } else {
        stations = this.locationList.filter(
          el =>
            el.siteType === 'DBS' ||
            el.siteType === 'DCU' ||
            el.siteType === 'DS',
        );
      }

      return stations;
    },

    //get all sites
    getLocations() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.region = this.regionId;
      params.status = 'active';
      params.$select = ['siteName', 'siteType', '_id', 'regionName', 'region', 'latitude', 'longitude'];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.locationList = res.data.docs;
          this.setLocationsData();
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },

    //set the data to input fields
    setLocationsData() {
      let data = this.trip.subTripDetails;
      let myData = [];
      let requiredList = [];

      data.forEach(function (element, index) {
        if (index === 0) {
          myData.push(element.startSite);
          myData.push(element.endSite);
        } else {
          myData.push(element.endSite);
        }
      });
      myData.forEach(element => {
        let locationData = [];
        let obj = {};
        locationData = this.locationList.filter(el => el._id === element);
        (obj['_id'] = locationData[0]._id),
          (obj['siteName'] = locationData[0].siteName),
          (obj['siteType'] = locationData[0].siteType),
          (obj['regionName'] = locationData[0].regionName),
          (obj['region'] = locationData[0].region),
          (obj['latitude'] = locationData[0].latitude),
          (obj['longitude'] = locationData[0].longitude),
          requiredList.push(obj);
      });

      while (this.locations.length < requiredList.length) {
        this.locations.push({
          locationId: ''
        });
      }
      for (let i = 0; i < requiredList.length; i++) {
        if (requiredList[i] && requiredList[i]._id) {
          this.locations[i].locationId = {
            _id: requiredList[i]._id,
            siteName: requiredList[i].siteName,
            siteType: requiredList[i].siteType,
            regionName: requiredList[i].regionName,
            region: requiredList[i].region,
            latitude: requiredList[i].latitude,
            longitude: requiredList[i].longitude,
          };
        } else {
          this.locations[i].locationId = '';
        }
      }
    },
    updateSubTrips() {
      this.loading = true;
      for (let indexx = 1; indexx < this.locations.length; indexx++) {
        const el = this.route_name.find(
          el =>
            this.locations[indexx - 1].locationId._id === el.startSite &&
            this.locations[indexx].locationId._id === el.endSite
        );
        if (el) {
          let val = {
            routeId: el._id,
            startSite: el.startSite,
            endSite: el.endSite,
          };
          this.matchingRoutes.push(val);
        }
      }
      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', this.matchingRoutes)
      let subTripDetails = {
        subtrips: this.matchingRoutes,
        _id: this.$route.params._id
      }

      return tripRouteService
        .updatesubTripRouteDetails(subTripDetails)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('route added!', 'Success!');
          this.$router.push('/trip-group')
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('trip Add failed! Try Again', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage = 'New route add is failed.Please try again!';
          }
        });
    },

    getSite() {
      this.loading = true;
      const params = {};
      params.$limit = 0;

      //params.roleRank = 4;
      let siteList = [];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            siteList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.siteName,
              };
            });
          }
          this.site_name = siteList;
        })
        .catch(error => {
          this.loading = false;
          console.error('site.requestFunction-error:', error);
          this.$snotify.error('Get site list failed', 'Error!');
        });
    },
    updateTrip() {
      this.loading = true;
      this.tripException = {
        ...this.tripException,
        recordedTime: new Date().toISOString(),
      };
      return tripExceptionService
        .addtripException(this.tripException)
        .then(response => {
          console.log('responseeeee', response);
          this.loading = false;
          this.flash = false;
          this.tripUpdateDone();
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Destination update failed', 'Error!');
        });
    },
    tripUpdateDone() {
      this.trip.endSite = this.tripException.divertedDestination;
      this.loading = true;
      this.trip = {
        ...this.trip,
        endSite: this.tripException.divertedDestination,
      };
      return tripService.updateTrip(this.trip).then(response => {
        this.loading = false;
        this.flash = false;
        this.$snotify.success('Destination has been updated!', 'Success!');
        this.$router.push('/trip-group');
      });
    },

    addField(fieldType) {
      this[fieldType].splice(-1, 0, { locationId: null });
    },
    removeField(index, fieldType) {
      console.log('index', index)
      console.log('fieldType', fieldType)
      this[fieldType].splice(index, 1);
    },

    handleChange(event, index) {
      this.clearIndex = index;
      const locations = this.locations;

      console.log('handleChange', this.locations)
      if (index > 0) {
        this.checkRoute(index);
      }
    },

    closeRoute() {
      this.$modal.hide('gasFlowDia');
      this.locations[this.clearIndex].locationId = '';
      this.clearRoute();
    },

    /*check if route exists between two locations or not */
    checkRoute(index) {

      const route = this.route_name.find(
        el =>
          this.locations[index - 1].locationId._id === el.startSite &&
          this.locations[index].locationId._id === el.endSite,
      );


      if (route) {
        let val = {
          routeId: route._id,
          startSite: route.startSite,
          endSite: route.endSite,
        };
        this.list.push(val);
      } else {
        this.$modal.show('gasFlowDia');
        this.routeData.startLocation = this.locations[
          index - 1
        ].locationId.siteName;
        this.routeData.endLocation = this.locations[index].locationId.siteName;
        this.routeData.startLocId = this.locations[index - 1].locationId._id;
        this.routeData.endLocId = this.locations[index].locationId._id;
        this.routeData.routeMarkers[0].latitude = this.locations[index - 1].locationId.latitude;
        this.routeData.routeMarkers[0].longitude = this.locations[index - 1].locationId.longitude;
        this.routeData.routeMarkers[0].message = this.locations[index - 1].locationId.siteName;
        this.routeData.routeMarkers[1].latitude = this.locations[index].locationId.latitude;
        this.routeData.routeMarkers[1].longitude = this.locations[index].locationId.longitude;
        this.routeData.routeMarkers[1].message = this.locations[index].locationId.siteName;
      }
    },
    clearRoute() {
      this.routeData.startLocation = '';
      this.routeData.endLocation = '';
      this.routeData.time = '';
      this.routeData.distance = '';
      this.routeData.routeMarkers[0].latitude = '';
      this.routeData.routeMarkers[0].longitude = '';
      this.routeData.routeMarkers[0].message = '';
      this.routeData.routeMarkers[1].latitude = '';
      this.routeData.routeMarkers[1].longitude = '';
      this.routeData.routeMarkers[1].message = '';
    },
    createRoute() {
      this.loading = true;
      let tripRoute = {
        approxDistance: this.routeData.distance,
        approxTime: this.routeData.time,
        status: 'active',
        startSite: this.routeData.startLocId,
        endSite: this.routeData.endLocId,
        region: this.regionId,
        reportAssessment: '',
        routeMarkers: this.routeData.routeMarkers,
      };

      return tripRouteService
        .addtripRoute(tripRoute)
        .then(response => {

          this.loading = false;
          this.flash = false;
          this.$snotify.success('route added!', 'Success!');
          this.clearRoute();

          this.getRouteName();
          this.checkRoute(this.clearIndex);
          this.$modal.hide('gasFlowDia');


        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('trip Add failed! Try Again', 'Error!');
          // if (error.data.message.includes('must be one of')) {
          //   this.flash = true;
          //   this.flashType = 'error';
          //   this.flashMessage = 'New route add is failed.Please try again!';
          // }
        });
    },

    //get the routes data
    getRouteName() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let routeList = [];
      this.$triprouteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            routeList = res.data.docs;
          }
          this.route_name = routeList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },

    fieldClassName: function (field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },

    created() {
      const promises = [];
      this.loading = true;
      promises.push(this.getLocations());
      Promise.all(promises)
        .then(() => {
          this.loading = false;
          this.ready = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.required-field>label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.gradientbt {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}

.box-header {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Update-Locations.vue?05e011f8